import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { MenuProvider } from './contexts/MenuContext';

import { GlobalStyles } from './components/GlobalStyles';
import Router from './components/Router';

function App() {
  return (
    <BrowserRouter>
      <GlobalStyles />
      <MenuProvider>
        <Router />
      </MenuProvider>
    </BrowserRouter>
  );
}

export default App;
